module.exports = __webpack_public_path__ + "img/bonus_symbol_3.dfbb05df.png";